import React, {useEffect, useContext} from "react";
import { Row, Col, Button } from "react-bootstrap";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import getNextPage from "./getNextPage";
import {RouterContext} from "./Onboarding"

export default function AccountConfigurationIntro(props) {
  const route = useContext(RouterContext)

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  props.pageLocator();
  return (
    <>
      <div className="account-configuration-intro">
        <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
        <Row className=" px-4 mb-3 pb-3 justify-content-center">
          <Col className="intro-text">
            <div>
              <p className="pb-3 f28 visby-bold primary text-center">First Up: Account Configuration</p>
            </div>
            <div>
              <p className=" f14 nunito-regular primary ">
                In the next few sections, the designated team member will set up the account configuration. We'll also set up any necessary configurations for
                services and subservices, depending on what was selected so far.
              </p>
            </div>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col>
            <div className="navButtonRow">
              <BackButton smaller />
              <NextButton
                validated={true} 
                btnText={`Let's do it`}
                nextPage={nextPage.url}
                invalidText={`We need more information on this page before you continue.`}
                submitForm={props.submitForm}
                className="goBtn"
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
